module.exports = __webpack_public_path__ + "static/media/answerPIC1.4e2ccd6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC1.png
// module id = 1717
// module chunks = 0 1